import { Link } from 'react-router-dom';
import FlightPathAnimation from '../../../components/feature/FlightPathAnimation';
import HeroVideoDemo from './HeroVideoDemo';

export default function HeroSection() {
  return (
    <div className="relative overflow-hidden">
      <FlightPathAnimation variant="hero" />

      <section className="relative z-10 pt-32 pb-20 md:pt-40 md:pb-28 px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Left — Copy */}
          <div className="w-full lg:w-1/2 flex flex-col gap-6">
            <div className="inline-flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-full px-3 py-1 w-fit">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block" />
              <span className="text-xs text-gray-600 font-medium">AI-powered • Built for Travel Agencies</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-[56px] font-semibold text-gray-900 leading-[1.15] tracking-tight">
              Automate Your<br />Travel Agency&nbsp;<span className="bg-gradient-to-r from-teal-500 to-indigo-500 bg-clip-text text-transparent">with AI</span>
            </h1>

            <p className="text-lg text-gray-500 leading-relaxed max-w-md">
              From first enquiry to confirmed booking — TreWaz automates your travel agency&apos;s entire workflow so you sell more holidays without growing your team.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <Link
                to="/register"
                className="bg-black text-white text-sm font-medium px-6 py-3 rounded-md hover:bg-gray-800 transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                Start Free Trial
              </Link>
              <a
                href="#how-it-works"
                className="border border-gray-200 text-gray-700 text-sm font-medium px-6 py-3 rounded-md hover:border-gray-400 hover:bg-gray-50 transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                Book a Demo
              </a>
            </div>

            <div className="flex items-center gap-6 pt-2">
              <div className="flex -space-x-2">
                {[
                  'https://public.readdy.ai/ai/img_res/2f9a90f3b3dd65071fb3e44add8e8ce2.jpg',
                  'https://readdy.ai/api/search-image?query=professional%20man%20business%20headshot%20portrait%20close%20up%20on%20white%20background%20minimalist&width=40&height=40&seq=h2&orientation=squarish',
                  'https://readdy.ai/api/search-image?query=professional%20woman%20entrepreneur%20headshot%20portrait%20on%20white%20background%20minimalist&width=40&height=40&seq=h3&orientation=squarish',
                ].map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt="customer"
                    className="w-8 h-8 rounded-full border-2 border-white object-top object-cover"
                  />
                ))}
              </div>
              <p className="text-sm text-gray-500">
                <strong className="text-gray-800">500+</strong> travel agencies automate with Trewaz
              </p>
            </div>
          </div>

          {/* Right — Animated Video Explainer */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end pt-6 lg:pt-0">
            <HeroVideoDemo />
          </div>
        </div>
      </section>
    </div>
  );
}
